import React from "react";
import { Row, Col } from "antd";
import styled from "styled-components";
import {
  YoutubeOutlined,
  WhatsAppOutlined,
  InstagramOutlined,
  TwitterOutlined,
} from "@ant-design/icons";
import nexuslogo from "../image/logonexus.png";
import { styles } from "../Header/AppHeaderstyle";
import { Link } from "react-router-dom";

const FooterContainer = styled.footer`
  background: linear-gradient(
    90deg,
    rgb(3, 13, 51),
    rgb(0, 53, 55),
    rgb(0 0 0)
  );
  padding: 40px 50px;

  .footer-content {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 20px;
  }

  .footer-icons {
    display: flex;
    gap: 15px;
    margin-top: 10px;

    .icon {
      width: 40px;
      height: 40px;
      border-radius: 50%;
      background: black;
      color: white;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 18px;
      cursor: pointer;
      transition: 0.3s ease;

      &:hover {
        background: #00a76f;
      }
    }
  }

  .footer-links h3 {
    font-size: 1.2rem;
    font-weight: bold;
    margin-bottom: 10px;
    color: white;
    text-align: center;
  }

  .footer-links a {
    display: block;
    color: white;
    font-size: 1rem;
    text-decoration: none;
    margin-bottom: 8px;
    transition: color 0.3s ease;
    text-align: center;

    &:hover {
      color: #00a76f;
    }
  }

  @media (max-width: 768px) {
    padding: 40px 20px;

    .footer-content {
      align-items: center;
      text-align: center;
    }

    .footer-icons {
      justify-content: center;
    }
  }
`;
const CopyrightText = styled.div`
  text-align: center;
  padding: 20px 0;
  font-size: 1rem;
  background: linear-gradient(
    90deg,
    rgb(3, 13, 51),
    rgb(0, 53, 55),
    rgb(0 0 0)
  );
  color: white;
  width: 100%;
`;

const Footer = () => {
  const Functionscrooll = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };
  return (
    <FooterContainer>
      <Row gutter={[32, 32]} justify="center">
        {/* Left Side - Description & Icons */}
        <Col xs={24} sm={24} md={24} lg={6} className="footer-content">
          {/* <p>
            Glasses are typically used for vision correction, such as with
            reading glasses and glasses used for nearsightedness; however,
            without the specialized lenses.
          </p> */}
          <Link to="/">
            <img src={nexuslogo} alt="Nexus Logo" style={styles.logosize} />
          </Link>
          <div className="footer-icons">
            <div className="icon">
              <a
                href="https://www.youtube.com/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <YoutubeOutlined />
              </a>
            </div>
            <div className="icon">
              <a
                href="https://wa.me/9284382353"
                target="_blank"
                rel="noopener noreferrer"
              >
                <WhatsAppOutlined />
              </a>
            </div>
            <div className="icon">
              <a
                href="https://www.instagram.com/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <InstagramOutlined />
              </a>
            </div>
            <div className="icon">
              <a
                href="https://twitter-cl.vercel.app/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <TwitterOutlined />
              </a>
            </div>
          </div>
        </Col>

        {/* Right Side - Links */}
        <Col xs={24} sm={24} md={24} lg={4} className="footer-links">
          <h3>Experience:</h3>
          <Link to="/Aboutus"  onClick={Functionscrooll}>About us</Link>
          <Link to="/contact"  onClick={Functionscrooll}>Contact</Link>
          <Link to="/contact"  onClick={Functionscrooll}>Asked Questions</Link>
        </Col>

        <Col xs={24} sm={24} md={24} lg={4} className="footer-links">
          <h3>Extras:</h3>
          <Link to="#"  onClick={Functionscrooll}>Search</Link>
          <Link to="/contact"  onClick={Functionscrooll}>Contact</Link>
        </Col>

        <Col xs={24} sm={24} md={24} lg={4} className="footer-links">
          <h3>Services:</h3>
          <Link to="#"  onClick={Functionscrooll}>Hotel Industry</Link>
          <Link to="#"  onClick={Functionscrooll}>Export-Import Industry</Link>
          <Link to="#"  onClick={Functionscrooll}>Textile Industry</Link>
          <Link to="#"  onClick={Functionscrooll}>Real Estate Industry</Link>
        </Col>

        <Col xs={24} sm={24} md={24} lg={4} className="footer-links">
          <h3>Quick Links:</h3>
          <Link to="/services"  onClick={Functionscrooll}>Services</Link>
          <Link to="/contact"  onClick={Functionscrooll}>Contact</Link>
          <Link to="/Aboutus"  onClick={Functionscrooll}>About Us</Link>
        </Col>
      </Row>
      <CopyrightText>
        Copyright © 2025 Nexus Wealth Services All Rights Reserved.
      </CopyrightText>
    </FooterContainer>
  );
};

export default Footer;
